import { render, staticRenderFns } from "./BatchReview.vue?vue&type=template&id=13e6f14c"
import script from "./BatchReview.vue?vue&type=script&lang=js"
export * from "./BatchReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports